import { BehaviorType, ICTColorDmlA, IEGTimeNodeChoice, IPageDataModel, STSchemeColorVal } from '@tencent/slide-sdk-model';
import { TDColor } from './td-color';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { colorStrToColorDmlA } from '@src/slide/infrastructure/module/independent/color/transform';

export const getSchemeColor = (color: number, pageDataModel?: IPageDataModel): TDColor | undefined => {
    if (!pageDataModel) return;
    const colorManager = SlideDataServices.SDKDataServices.ColorManager();
    const colorDmlA = colorStrToColorDmlA(STSchemeColorVal[Number(color)]);
    const srgb = colorManager?.resolveColor(colorDmlA, pageDataModel)?.srgbClr?.val;
    return new TDColor({ themeKey: color, rgbaStr: srgb });
};

export const getRgbColor = (color: number): TDColor | undefined => new TDColor({ rgbaStr: `#${color}` });

const getColor = (colorObj: ICTColorDmlA, pageDataModel?: IPageDataModel): TDColor | undefined => {
    const [key] = Object.keys(colorObj);
    const handlerMap = {
        schemeClr: () => getSchemeColor(colorObj[key].val, pageDataModel),
        srgbClr: () => getRgbColor(colorObj[key].val),
    };

    return handlerMap[key]?.();
};

export const getInitialColor = (
    choiceList: IEGTimeNodeChoice[],
    pageDataModel?: IPageDataModel,
): TDColor | undefined => {
    let setBehaviorClr: ICTColorDmlA | undefined;
    for (const choice of choiceList) {
        const [behaviorName] = Object.keys(choice);
        if (behaviorName === BehaviorType.animClr) {
            const behaviorObj = choice[behaviorName];
            const toObj = behaviorObj?.to;
            if (!toObj) return;
            return getColor(toObj, pageDataModel);
        }

        if (!setBehaviorClr && behaviorName === BehaviorType.set && choice.set?.to?.clrVal) {
            setBehaviorClr = choice.set.to.clrVal;
        }
    }
    return setBehaviorClr && getColor(setBehaviorClr, pageDataModel);
};
